import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { fetchShowActivity } from '../../features/Activity/ShowActivity';
import { convertDate } from '../../features/ConvertDate';
import OtherActivity from './OtherActivity';
import { motion } from 'framer-motion';
import ShowModalImage from '../Modal/ShowModalImage';
import { useTranslation } from 'react-i18next';
import Loading from '../Loading/Loading';
import ShowMultiImageModal from '../Modal/ShowMultiImageModal';

function ShowActivityPage() {
  const dispatch = useDispatch();
  const { id } = useParams();
  const { activity, loading, error } = useSelector((state) => state.showActivity);
  // const [selectedImage, setSelectedImage] = useState(null);
  const { i18n } = useTranslation();
  useEffect(() => {
    if (id) {
      dispatch(fetchShowActivity(id));
    }
  }, [dispatch, id, i18n.language]);
  const [isOpenModalImage, setIsOpenModalImage] = useState(false);
  if (loading) return <Loading />;
  if (error) return <p className="text-center text-red-500">Error: {error}</p>;



  return (
    <>
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: -20 }}
        transition={{ duration: 0.6 }}
        className="max-w-3xl mx-auto p-6 space-y-6"
      >
        <motion.h1
          className="text-4xl font-extrabold text-gray-800"
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2, duration: 0.5 }}
        >
          {activity?.title || "No Title"}
        </motion.h1>
        <motion.p
          className="text-teal-700 text-lg"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.4, duration: 0.5 }}
        >
          {convertDate(activity?.published_at)}
        </motion.p>
        <motion.div
          className="overflow-hidden rounded-xl"
          initial={{ scale: 0.9, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ delay: 0.6, duration: 0.5 }}
        >
          <img
            src={process.env.REACT_APP_IMG_URL + activity?.image}
            alt="Activity"
            style={{ aspectRatio: '16/9' }}
            className="  rounded-xl object-cover hover:scale-105 transition-transform duration-500"
            onClick={() => setIsOpenModalImage(true)}
          />
        </motion.div>
        <motion.div
          className="text-gray-600 px-4 text-lg leading-relaxed break-words"
          dangerouslySetInnerHTML={{ __html: activity?.description || "<p>No Description</p>" }}
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.8, duration: 0.5 }}
        />
        <motion.div className="grid grid-cols-4 gap-3">
          {activity?.images?.map((image, index) => (
            <motion.img
              key={index}
              src={process.env.REACT_APP_IMG_URL + image}
              alt={`Image ${index}`}
              className="w-full h-32 rounded-xl object-contain hover:scale-105 transition-transform duration-500 cursor-pointer"
              onClick={() => setIsOpenModalImage(true)}
            />
          ))}
        </motion.div>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 1, duration: 0.5 }}
        >

        </motion.div>
      </motion.div>
      {
        activity?.link && <div className="relative w-full max-w-4xl mx-auto overflow-hidden rounded-2xl border border-gray-200 shadow-lg bg-gray-100 transition-all duration-300 hover:shadow-2xl">
          <div className="relative pt-[56.25%]"> {/* 16:9 Aspect Ratio */}
            <iframe
              src={activity?.link}
              className="absolute top-0 left-0 w-full h-full rounded-2xl"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          </div>
        </div>
      }

      <OtherActivity expectId={id} />
      <ShowMultiImageModal images={activity?.images} startIndex={0} isOpen={isOpenModalImage} onClose={() => setIsOpenModalImage(false)} />

    </>
  );
}

export default ShowActivityPage;
